import { Button, Checkbox, InputCheckbox, } from '@yellowcard/components-library-vue3';
import { computed, defineComponent } from 'vue';
import { useKycStore } from '@/store/modules/kyc';
import { useAuthStore } from '@/store/modules/auth';
import { storeToRefs } from 'pinia';
import { KycTypes } from '@/types/kyc';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
import validator from 'validator';
import { nameIsInvalid as sourceOfFundsIsValid } from '@/utils/helpers';
export default defineComponent({
    name: 'SourceOfFunds',
    props: {},
    components: {
        InputCheckbox,
        Checkbox,
        Button,
    },
    setup() {
        const kycStore = useKycStore();
        const { currentStep, fundDetails: userInput } = storeToRefs(kycStore);
        const authStore = useAuthStore();
        const { partnerId } = storeToRefs(authStore);
        let checkedFunds = [];
        const initializeCheckedFunds = () => {
            const selectedValues = [...userInput.value.funds];
            checkedFunds = selectedValues
                .filter((selectedValue) => KycTypes.FundsMapping[selectedValue] !== undefined)
                .map((selectedValue) => KycTypes.FundsMapping[selectedValue]);
        };
        initializeCheckedFunds();
        const backClick = () => {
            currentStep.value = KycTypes.KycSteps.KYC_3;
        };
        const rules = computed(() => ({
            sourceOfFunds: (value) => {
                if (validator.isEmpty(value) || sourceOfFundsIsValid(value))
                    return ' ';
                return true;
            },
        }));
        const validateSourceOfFunds = (input) => !(rules.value.sourceOfFunds(input) === true);
        const isButtonDisabled = computed(() => (userInput.value.funds.length === 0 &&
            !userInput.value.otherSelected) ||
            (userInput.value.otherSelected &&
                validateSourceOfFunds(userInput.value.otherFunds)));
        const onKeyPress = () => {
            console.log('key pressed');
        };
        const fundsArray = (value) => {
            userInput.value.funds = value;
        };
        const boxChecked = (value) => {
            userInput.value.otherSelected = value;
            if (!value) {
                userInput.value.otherFunds = '';
            }
        };
        const otherText = (value) => {
            userInput.value.otherFunds = value;
        };
        const proceed = () => {
            // submit data to be
            userInput.value.funds = userInput.value.funds.map(input => {
                const matchingKey = Object.keys(KycTypes.FundsMapping).find(key => KycTypes.FundsMapping[key].toLowerCase() === input.toLowerCase());
                return matchingKey || input.toLowerCase();
            });
            if (userInput.value.otherSelected && userInput.value.otherFunds !== '') {
                userInput.value.funds.push(userInput.value.otherFunds);
            }
            userInput.value.funds = [...new Set(userInput.value.funds)];
            trackEvent(MIXPANEL_EVENTS.KYC.SOURCE_OF_FUNDS, {
                partner: partnerId.value,
            });
            currentStep.value = KycTypes.KycSteps.KYC_5;
        };
        return {
            backClick,
            proceed,
            userInput,
            isButtonDisabled,
            onKeyPress,
            fundsArray,
            boxChecked,
            otherText,
            checkedFunds,
            rules,
        };
    },
});
